import { inject } from 'vue'
import { RequestService } from './RequestService'
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore'
import { getApp } from 'firebase/app'
import { isNil } from 'lodash'
import { isLeapYear } from '../components/Reminders/dateUtils'

const { simpleGet, post } = RequestService()

export const RemindersCalendarService = () => {
  const functionsBaseUrl = inject('functionsBaseUrl')
  const nameMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const { handleErrors } = RequestService()

  function getNumberOfWeek(month, day) {
    const dateObj = new Date(new Date().getFullYear(), month - 1, day)
    const firstDayOfMonth = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1)
    const weekNumber = Math.ceil((dateObj.getDate() + firstDayOfMonth.getDay()) / 7)
    return weekNumber
  }

  async function getEvents(startMonth, type = 0) {
    try {
      if (isNil(type)) type = 0
      const response = await simpleGet(
        'getComplianceEvents',
        `${functionsBaseUrl}/calendarGateway/api/v1/compliance-events?type=${type}&plan_start_month=${startMonth}`
      )
      return response.data.data?.results
    } catch (error) {
      handleErrors('getComplianceEvents', error)
    }
  }

  async function getEmails() {
    try {
      const response = await simpleGet(
        'getEmails',
        `${functionsBaseUrl}/usersGateway/api/v1/users/account-owners`,
        { rethrow: true }
      )
      return (response?.data?.data || []).map(owner => ({ email: owner.email }))
    } catch (error) {
      handleErrors('getEmails', error)
    }
  }

  async function getGoogleReminders(id) {
    const db = getFirestore(getApp())
    const q = query(
      collection(db, 'reminders_sent'),
      where('plan_year_id', '==', id)
    )
    const snap = await getDocs(q)
    
    if (snap.empty) {
      return { results: [], total: 0 }
    }
    
    const reminders = snap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    
    return {
      results: reminders,
      total: reminders.length
    }
  }


  async function postReminders(params2) {
    try {
      const response = await post(
        'postReminders',
        `${functionsBaseUrl}/calendarGateway/api/v1/reminders`,
        params2
      )
      return response
    } catch (error) {
      handleErrors('Error posting reminders:', error)
    }
  }

  async function postBatchReminders(params) {
    try {
      const response = await post(
        'postBatchReminders',
        `${functionsBaseUrl}/calendarGateway/api/v1/reminders/batch`,
        params
      )
      return response
    } catch (error) {
      handleErrors('Error posting batch reminders:', error)
      throw error
    }
  }

  async function getReminders(startMonth, type = 0) {
    try {
      if (isNil(type)) type = 0
      const response = await simpleGet(
        'getReminders',
        `${functionsBaseUrl}/calendarGateway/api/v1/compliance-events?type=${type}&plan_start_month=${startMonth}`
      )
      
      const currentYear = new Date().getFullYear()
      const currentYearIsLeap = isLeapYear(currentYear)
      let monthsWithEvents = {}
      let reminders = response.data?.data?.results

      // In non-leap years, convert "2/29" to "3/1" so the event appears in March
      if (!currentYearIsLeap) {
        reminders = reminders.map((reminder) => {
          if (reminder.date === '2/29') {
            return { ...reminder, date: '3/1' }
          }
          return reminder
        })
      }
      
      for (let i = 0; i < 12; i++) {
        let monthNumber = (startMonth + i) % 12
        let month = nameMonths[monthNumber]
        monthsWithEvents[month] = {
          'Week 1': [],
          'Week 2': [],
          'Week 3': [],
          'Week 4': [],
          'Week 5': []
        }
        reminders = reminders.filter((reminder) => {
          if (reminder.date) {
            let [reminderMonth, day] = reminder.date.split('/').map(Number)
            if (reminderMonth === monthNumber + 1) {
              let weekNumber = getNumberOfWeek(reminderMonth, day)
              weekNumber = weekNumber > 5 ? 5 : weekNumber
              monthsWithEvents[month][`Week ${weekNumber}`].push(reminder)
              return false
            } else {
              return true
            }
          } else {
            monthsWithEvents['January'][`Week ${1}`].push({
              ...reminder,
              date: 'Error: Date is missing'
            })
            return false
          }
        })
      }
      return monthsWithEvents
    } catch (error) {
      handleErrors(`RemindersCalendarService - getReminders - Error get definition from server for id: ${type}`, error)
      return {}
    }
  }

  return {
    nameMonths,
    getReminders,
    getEvents,
    getEmails,
    postReminders,
    postBatchReminders,
    getGoogleReminders
  }
}
